import { _StoredObjects } from "./_StoredObjects";
import { StoredObjectType } from "./Api";
import { endpoints } from "./endpoints";
import { deepClone } from "./utils/deepClone";

export class Preferences extends _StoredObjects {
  NAME = "__GLOBAL_ACCOUNT_PREFERENCES__";
  VERSION = "2.0";

  storedObjectType = "PREFERENCE_GENERIC" as const;

  clone(target: any, source: any) {
    const clonedSource = deepClone(source);
    const clonedTarget = deepClone(target);
    for (const key in clonedSource) {
      clonedTarget[key] = clonedSource[key];
    }
    return clonedTarget;
  }

  /**
   * Decode server params in UI params
   */
  decode(object: any, type?: StoredObjectType) {
    let decoded = deepClone(object);

    decoded["name"] =
      type === "ALERTS_NEWS_FILTER"
        ? "__ALERTS_NEWS_ACCOUNT_FILTERS__"
        : this.NAME;
    decoded["version"] = this.VERSION;

    return decoded;
  }

  /**
   * Encode UI params in server params
   */
  encode(object: any, type: StoredObjectType | null, accountPreference: any) {
    var encoded = deepClone(object);
    var accountPreferences: any =
      /*this.environment.account.user?.preferences*/ accountPreference;
    var accountNewsFilters: any =
      /*this.environment.account.user?.alertsNewsFilters*/ null;

    if (type !== "ALERTS_NEWS_FILTER") {
      encoded["id"] =
        accountPreferences != null ? accountPreferences?.id : null;
    } else {
      encoded["id"] =
        accountNewsFilters != null ? accountNewsFilters?.id : null;
    }

    encoded["name"] =
      type === "ALERTS_NEWS_FILTER"
        ? "__ALERTS_NEWS_ACCOUNT_FILTERS__"
        : this.NAME;
    encoded["version"] = this.VERSION;

    if (encoded["preferences"] != null) {
      var preferences = encoded["preferences"];
      // #region ----------------------- migrate report 2017-09-18 - START
      if ("report" in preferences) {
        if (preferences["report"] == null) {
          encoded["preferences"]["report"] = {
            general: {
              disclaimer: null,
              logo: null,
              theme: null,
            },
          };
        } else if (!("general" in preferences["report"])) {
          encoded["preferences"]["report"] = {
            general: {
              disclaimer: null,
              logo: {
                base64: preferences["report"]["logo"]["base64"],
                url: null,
              },
              theme: null,
            },
          };
        } else {
          encoded["preferences"]["report"] = {
            general: this.clone(
              {
                disclaimer: null,
                logo: null,
                theme: null,
              },
              preferences["report"]["general"]
            ),
          };
        }
      } else {
        encoded["preferences"]["report"] = null;
      }
    }

    // #endregion ---------------------- migrate report 2017-09-18 - END

    return encoded;
  }

  async save(
    object: any,
    objectType: StoredObjectType | null,
    accountPreference: any
  ) {
    const type = objectType ?? null;
    var encoded = this.encode(object, type, accountPreference);

    let response;
    if (encoded["id"] == null) {
      return null;
      //   response = await this.create(encoded, type);
    } else {
      response = await this.update(encoded, type, accountPreference.ownerId);
    }

    // return this.decode(response);
    return response;
  }

  async get(soredObjectId: number, type: StoredObjectType, ownerId: number) {
    const response = await super.get(soredObjectId, type, ownerId);

    if (response.length === 0) {
      return null;
      //   return this.decode({
      //     preferences: defaultPreferences,
      //   });
    }

    return this.decode(response, type);
  }

  async select(objectType: StoredObjectType, userId: number) {
    if (!objectType) {
      throw new Error("Preference type is not defined");
    }

    let url: string = this.endPointRoot + endpoints.storedObjects.select;
    // const userId = this.environment.account.user?.id;

    const payload = {
      searches: [
        {
          filters: [
            {
              dimension: "type",
              segments: [objectType],
            },
            {
              dimension: "ownerId",
              segments: [userId],
            },
          ],
        },
      ],
    };

    try {
      const response = await this.preparePost(url, payload);
      return response?.data?.ids;
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
}
